import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Card as AntdCard } from 'antd';
import classnames from 'classnames';
import './panel.less';

class PanelSection extends Component {
  static propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    style: PropTypes.object,
    className: PropTypes.string,
    footer: PropTypes.element
  };
  render() {
    const { title, subtitle, style, className, children, footer } = this.props;
    return (
      <div className="panel__section">
        {title && (
          <div className={'panel__section-head'}>
            <div className={'panel__section-title'}>{title}</div>
          </div>
        )}
        {subtitle ? (
          <div className={'panel__section-subtitle'}>{subtitle}</div>
        ) : null}
        <div
          style={style}
          className={classnames(className, 'panel__section-body')}
        >
          {children}
        </div>
        {footer ? (
          <div className={'panel__section-footer'}>{footer}</div>
        ) : null}
      </div>
    );
  }
}

export default class Panel extends Component {
  state = {
    folded: null
  };
  static propTypes = {
    title: PropTypes.string,
    extra: PropTypes.element,
    subtitle: PropTypes.string,
    style: PropTypes.object,
    className: PropTypes.string,
    unpadded: PropTypes.bool,
    small: PropTypes.bool,
    disabled: PropTypes.bool,
    footer: PropTypes.element,
    foldable: PropTypes.bool,
    folded: PropTypes.bool
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.folded !== null && this.state.folded === null) {
      this.setState({ folded: nextProps.folded });
    }
  }

  static Section = PanelSection;

  onClickFold = () => {
    this.setState({ folded: !this.state.folded });
  };

  render() {
    const {
      style,
      className,
      disabled,
      small,
      unpadded,
      title,
      extra,
      subtitle,
      children,
      footer,
      foldable,
      loading
    } = this.props;
    const { folded } = this.state;
    return (
      <AntdCard
        loading={loading}
        style={style}
        hoverable={true}
        className={classnames(
          className,
          {
            disabled,
            small,
            unpadded,
            foldable,
            folded
          },
          'panel'
        )}
        title={foldable ? <div onClick={this.onClickFold}>{title}</div> : title}
        extra={
          foldable ? (
            <div onClick={this.onClickFold} className={''}>
              {extra}
            </div>
          ) : (
            extra
          )
        }
      >
        {subtitle ? (
          <div className={'panel__section-subtitle'}>{subtitle}</div>
        ) : null}
        <div className={'panel__section-body'}>{children}</div>
        {footer ? (
          <div className={'panel__section-footer'}>{footer}</div>
        ) : null}
      </AntdCard>
    );
  }
}
